export const SET_TAGS = "SET_TAGS";
